import { render } from "./index.vue?vue&type=template&id=3b88e1ec"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"static/js/components-wa/ads/FontAwesomeAd/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3b88e1ec"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3b88e1ec', __exports__)) {
    api.reload('3b88e1ec', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=3b88e1ec", () => {
    api.rerender('3b88e1ec', render)
  })

}


export default __exports__